module.exports = __webpack_public_path__ + "img/extra-modal.e0ca2c88.svg";